//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "../services/constants";
import html2pdf from "html2pdf.js";
import unity from "@/unity/unity";
import PDFTimesheetReport from "@/utils/pdfClientTimesheetReport";
import moment from "moment";

export default {
  async mounted() {
    // this.$showLoader();
    await api.checkVersion();
    this.mycompany_id = localStorage.getItem(server.COMPANYID);
    await this.loadEmp();
    await this.loadCustomer();
    await this.loadTimesheetno();
    await this.loadJobtitle();
    await this.loadDepartmentByCompanyId();
    await this.loadCompany();
    if (this.$route.params.timesheet_no) {
      let getdata = this.timesheetno_list.filter(item => {
        if (item.timesheet_id == this.$route.params.timesheet_no) {
          return item.id;
        }
      })
      if (getdata && getdata.length > 0) {
        this.datasearch.timesheet_hid = getdata[0].id;
      }
      this.SearchAlldata()
    }
    setTimeout(() => {
      this.$hideLoader();
    }, 500);
  },
  components: {
    SuccessDialog,
  },
  computed: {
    computedDateFromFormatted() {
      return unity.formatDate(this.datasearch.datefrom);
    },
    computedDateToFormatted() {
      return unity.formatDate(this.datasearch.dateto);
    },
  },
  data() {
    return {
      dialogSelectClientInfo: "1",
      dialogSelectTitle: false,
      showchargetype: "",
      checkdepartmentname: "",
      lengthAlldatasearch: 0,
      menudateto: false,
      menudatefrom: false,
      mycompany_id: 0,
      datasearch: {
        employee_id: localStorage.getItem(server.USER_ID),
        customername: "",
        timesheet_hid: 0,
        jobtitle_id: 0,
        chargetype: "",
        // datefrom: "",
        // dateto: "",
        datefrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        // company_id: 13,
        company_id: localStorage.getItem(server.COMPANYID),
      },
      getnamesignature: [],
      prpoheader: [],
      memoref_list: [],
      no_list: [],
      mysignature: "",
      approvesignature: "",
      opensummarize: false,
      datashowAll: [],
      setdatatoshow: [],
      dataforshowprpo: [
        // {
        //   DESCRIPTION: "Procurement - Tunnel",
        //   DIMENSION2_: "ENG-PJ-EP-21-007",
        //   ITEMID: "EN21007002",
        //   IVZ_BUDGETACCOUNT: "BEEQP-EN21007002",
        //   IVZ_BUDGETMODELID: "PJEP21-007",
        //   NAME:
        //     "Procurement - Tunnel\nค่าอากรขาเข้า \nค่าภาษีมูลค่าเพิ่ม \n\nRef No : 39280\nDate : 16/08/2565\nPP Business Coporation\n**ดำเนินการแล้วเสร็จ**",
        //   PURCHQTY: 1,
        //   PURCHREQID: "PR22-004569",
        //   PURCHUNIT: "ea",
        // },
      ],
      getheightcontentpr: 0,
      pageAll: 1,
      previewattachimage: "",
      dataformatpr: {
        title: "",
        subtitle: "Time Sheet Monthly Report",
        paymenttype: "Payment Type",
        companyname_addressrow1:
          "เลขที่ 142 อาคาร ทู แปซิฟิค เพลส ชั้น20 ถนนสุขุมวิท แขวงคลองเตย",
        companyname_addressrow2: "เขตคลองเตย กรุงเทพฯ 10110",
        pr_number: "เลขที่ใบขอซื้อ/PR Number",
        pr_date: "วันที่/PR Date",
        companyname_tel: "โทรศัพท์/Tel. 02-6530489-9",
        companyname_fax: "โทรสาร/Fax. 02-6533706",
        prtitle_th: "ใบขอซื้อ",
        prtitle_en: "PURCHASE REQUISTION",
      },
      dataformatprdetail: {
        project: "โครงการ/Project",
        department: "แผนก/Department",
        requist_date: "วันที่ต้องการ/Requist date",
        type: "ประเภท/Type",
        date_period: "วันที่เริ่มต้น-สิ้นสุด/Date period",
        objective: "วัตถุประสงค์/PR Name",
        vender: "ชื่อผู้จำหน่าย/Vender",
      },
      department_list: [],
      charge_list: [
        { value: "T/C", name: "Time Charge" },
        { value: "N/C", name: "No Charge" },
        { value: "F/C", name: "Fix Charge" },
        { value: "OFF", name: "ทำงานออฟฟิต" },
      ],
      isShowPassword: false,
      fullPage: true,
      dialogEdit: false,
      dialogDelete: false,
      dialogAdd: false,
      dialogSendMail: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      closeDelete: false,
      deleteItemConfirm: false,
      emp_list: [],
      jobtitle_list: [],
      customer_list: [],
      timesheetno_list: [],
    };
  },
  methods: {
    async loadEmp() {
      const result = await api.getAccountslist_by_ComID(
        localStorage.getItem(server.COMPANYID)
      );

      this.emp_list = result.data;
    },
    async loadJobtitle() {
      const result = await api.getAllJobtitleByCompany(
        localStorage.getItem(server.COMPANYID)
      );

      this.jobtitle_list = result.data;
    },
    async loadCustomer() {
      const result = await api.getAllCustomerListactiveCompany(
        {
          params: {
            company_id: localStorage.getItem(server.COMPANYID),
          },
        }
      );
      this.customer_list = result.data;
    },
    async loadTimesheetno() {
      const result = await api.getByIdtimesheetHBycompany(
        localStorage.getItem(server.COMPANYID)
      );

      this.timesheetno_list = result.data;
    },
    async loadCompany() {
      let copany_datat = await api.getCompanyByID(localStorage.getItem(server.COMPANYID));
      this.dataformatpr.title = copany_datat.data[0].name;
    },
    async loadDepartmentByCompanyId() {
      let result = await api.getAllDepartment_By_CompanyID(this.mycompany_id);

      this.department_list = result.data;
    },
    findChaege(chargetype) {
      this.charge_list.filter((item, index) => {

        if (item.value == chargetype) {
          this.showchargetype = item.name;
          return;
        }
      });
    },
    async OnSearchDepartment() {

    },
    async opendata() {
      if (Number(localStorage.getItem(server.COMPANYID)) != 1 && Number(localStorage.getItem(server.COMPANYID)) != 3) {
        await this.SearchAlldata()
      } else {
        this.dialogSelectTitle = true;
      }
    },
    async SearchAlldata() {
      this.dialogSelectTitle = false;
      this.datashowAll = [];

      if (!this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (!this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center"
        );
        return;
      }
      await this.$showLoader();
      this.lengthAlldatasearch = 0;
      this.datashowAll = [];
      const result = await api.getActivityforclientsummaryreport({
        params: this.datasearch,
      });
      // this.dataforshowprpo = result.data;

      if (result.data.length == 0) {
        await this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "ไม่มีข้อมูล",
          "text-h5 red--text text-center"
        );
        return;
      }
      this.lengthAlldatasearch = result.data.length;

      result.data.forEach(async (x, index) => {
        this.dataforshowprpo[0] = x;

        await this.checkcontent(this.dataforshowprpo[0]);
      });

      const headerPDF = await this.buildClientHeader();
      const clients = this.buildClientsFromData();

      const mockData = {
        header: headerPDF,
        clients: clients
      };

      PDFTimesheetReport.previewPDF(mockData);
      await this.$hideLoader();
    },
    async checkcontent(data) {
      let totalclient = 0;

      // alert(data.length);
      this.setdatatoshow = [];
      let linedetailprpo = 40;
      let datainlineprpo = 45;
      let addnewbutget = 1;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAll = 1;
      let newhllinedetails = 0;
      for (let i = 0; i < this.dataforshowprpo[0].length; i++) {
        let stringchecklength = "";
        let lengthofdataforshowprpo = this.dataforshowprpo[0][i].detail.length;

        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก
        newhllinedetails = 0;
        getnewdata = [];
        this.dataforshowprpo[0][i].no = i + 1;
        totalclient += parseFloat(
          this.dataforshowprpo[0][i].duration
            ? this.dataforshowprpo[0][i].duration
            : 0
        );
        if (i == 0) {
          this.checkdepartmentname = this.dataforshowprpo[0][i].job_name;
          this.dataforshowprpo[0][i].changedepartment = true;
        } else {
          if (
            this.checkdepartmentname !== this.dataforshowprpo[0][i].job_name
          ) {
            this.dataforshowprpo[0][i].changedepartment = true;
            this.checkdepartmentname = this.dataforshowprpo[0][i].job_name;
            hllinedetails++;
          }
        }
        stringchecklength = this.dataforshowprpo[0][i].detail;

        // let myArrayname = this.dataforshowprpo[i].NAME.split("\n");
        // for (let a = 0; a < myArrayname.length; a++) {
        //   let lengthnewline = myArrayname[a].length;
        //   for (let b = 0; b < myArrayname[a].length; b++) {
        //     if (
        //       myArrayname[a][b] == maiek ||
        //       myArrayname[a][b] == maito ||
        //       myArrayname[a][b] == maitree ||
        //       myArrayname[a][b] == maijattawa ||
        //       myArrayname[a][b] == vowelei ||
        //       myArrayname[a][b] == vowelee ||
        //       myArrayname[a][b] == voweleue ||
        //       myArrayname[a][b] == voweleu ||
        //       myArrayname[a][b] == vowelu ||
        //       myArrayname[a][b] == voweluu ||
        //       myArrayname[a][b] == maihun ||
        //       myArrayname[a][b] == maiyamok
        //     ) {
        //       lengthnewline--;
        //     }

        //   }

        for (let j = 0; j < this.dataforshowprpo[0][i].detail.length; j++) {
          if (
            stringchecklength[j] == maiek ||
            stringchecklength[j] == maito ||
            stringchecklength[j] == maitree ||
            stringchecklength[j] == maijattawa ||
            stringchecklength[j] == vowelei ||
            stringchecklength[j] == vowelee ||
            stringchecklength[j] == voweleue ||
            stringchecklength[j] == voweleu ||
            stringchecklength[j] == vowelu ||
            stringchecklength[j] == voweluu ||
            stringchecklength[j] == maihun ||
            stringchecklength[j] == maiyamok
          ) {
            lengthofdataforshowprpo--;
          }
        }
        newhllinedetails = Math.ceil(lengthofdataforshowprpo / datainlineprpo);

        // newhllinedetails = Math.ceil(
        //   this.dataforshowprpo[i].NAME.length / datainlineprpo
        // );

        // newhllinedetails += addnewbutget;
        getnewdata.push(this.dataforshowprpo[0][i]);

        if (hllinedetails + newhllinedetails > linedetailprpo) {

          this.setdatatoshow[this.pageAll - 1] = getdata;
          this.pageAll++;

          hllinedetails = 0;
          getdata = [];
          getdata.push(this.dataforshowprpo[0][i]);
          hllinedetails += newhllinedetails;
          if (i == this.dataforshowprpo[0].length - 1) {
            this.dataforshowprpo[0][i].totalclient = totalclient.toFixed(2);
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        } else {
          hllinedetails += newhllinedetails;

          getdata.push(this.dataforshowprpo[0][i]);

          if (i == this.dataforshowprpo[0].length - 1) {
            this.dataforshowprpo[0][i].totalclient = totalclient.toFixed(2);
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        }
      }
      this.pageAll += this.lengthAlldatasearch - 1;
      this.opensummarize = true;


      this.setdatatoshow.forEach((item, iitem) => {

        if (iitem == this.setdatatoshow.length - 1) {
          item[this.setdatatoshow[iitem].length - 1].lastdata = "lastindex";
        }

        this.datashowAll.push(item);
      });

    },
    buildClientsFromData() {
      const data = this.datashowAll || [];

      const clientsMap = {};

      data.forEach((group) => {
        if (!Array.isArray(group)) return;

        group.forEach((item) => {
          const customerName = item.customer_name || "Unspecified Client";

          // ================= INIT CLIENT =================
          if (!clientsMap[customerName]) {
            clientsMap[customerName] = {
              client_name: customerName,
              items: [],
            };
          }

          // ================= ASSIGNMENT =================
          const assignment =
            item.job_name?.trim() || "Unspecified";

          // ================= PUSH ITEM =================
          clientsMap[customerName].items.push({
            assignment: assignment,

            date: item.checkindate || null,

            case_worker: item.abbname_e_n || "",

            detail: item.detail || "",

            hour: item.duration || 0,

            chargetype: item.chargetype || "",
          });
        });
      });

      // ================= SORT: Unspecified LAST =================
      const clients = Object.values(clientsMap);

      clients.forEach((client) => {
        const grouped = {};

        client.items.forEach((item) => {
          const key = item.assignment;

          if (!grouped[key]) grouped[key] = [];
          grouped[key].push(item);
        });

        const sortedKeys = Object.keys(grouped).sort((a, b) => {
          if (a === "Unspecified") return 1;
          if (b === "Unspecified") return -1;
          return a.localeCompare(b);
        });

        client.items = sortedKeys.flatMap((key) => grouped[key]);
      });

      return clients.sort((a, b) => {
        const nameA = a.client_name || "";
        const nameB = b.client_name || "";

        // ================= Unspecified ไปท้ายสุด =================
        const isUnA = nameA === "Unspecified Client";
        const isUnB = nameB === "Unspecified Client";

        if (isUnA && !isUnB) return 1;
        if (!isUnA && isUnB) return -1;

        // ================= เรียง A-Z =================
        return nameA.localeCompare(nameB, "en", {
          sensitivity: "base",
        });
      });
    },
    async buildClientHeader() {

      var res_company = [];
      if (Number(localStorage.getItem(server.COMPANYID)) != 1) {
        res_company = await api.getCompanyByID(localStorage.getItem(server.COMPANYID))
      } else {
        res_company = await api.getCompanyByID(Number(this.dialogSelectClientInfo))
      }

      var headerPDF = {};

      headerPDF = {
        company_name_en: res_company.data[0].name || "",
        inv_company_sub_name: "ATTORNEY AT LAW",
        company_name_th: res_company.data[0].inv_company_name_th || "",
        date_from: this.datasearch.datefrom,
        date_to: this.datasearch.dateto,
        issue_date: moment().format("YYYY-MM-DD"),
      }
      if (Number(localStorage.getItem(server.COMPANYID)) != 1) {
        headerPDF.inv_company_sub_name = "";
      }
      return headerPDF;
    },
    async exportToPDF() {
      await this.$showLoader();

      const headerPDF = await this.buildClientHeader();
      const clients = this.buildClientsFromData();

      const mockData = {

        header: headerPDF,
        clients: clients

      };

      await PDFTimesheetReport.exportToPDF(mockData);
      await this.$hideLoader();
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
  },
  beforeCreate() {

    this.$store.state.navMenu = true;
  },
};
